import { ARTIST } from '../config';

export default function Wordmark({ as: Tag = 'span', className = '' }) {
  return (
    <Tag className={`font-display font-black uppercase tracking-tight [font-stretch:125%] ${className}`}>
      {ARTIST}
    </Tag>
  );
}
